export default "__VITE_ASSET__D3KA_r4r__"